import React from 'react';

const CourseFormModal = React.lazy(() => import('../components/FormModal'));
const courseModalRegistry = {
    community_courseId: CourseFormModal
};
export default courseModalRegistry;
